'use strict';
import classNames from 'classnames';
import isFunction from 'lodash/isFunction';
import isUndefined from 'lodash/isUndefined';
import noop from 'lodash/noop';
import * as T from 'prop-types';
import React, {Component} from 'react';


export class ListItem extends Component {
  static propTypes = {
    className: T.string,
    disabled: T.bool,
    title: T.string,
    bindParam: T.any,
    onClick: T.func,
    onContextMenu: T.func,
    /** @type {Boolean} Pass true if using a dynamic onContextMenu event to force the polyfill to activate */
    useContextMenu: T.bool,
  };

  static defaultProps = {
    useContextMenu: false,
  };

  static $inject = [
    'contextMenuPolyfillService',
  ];

  constructor(props) {
    super(props);
    this.state = {
      active: false,
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleContextMenu = this.handleContextMenu.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);

    if (ListItem.dependencies.contextMenuPolyfillService.usePolyfill()) {
      this.handleTouchStart = this.handleTouchStart.bind(this);
      this.handleTouchMove = this.handleTouchMove.bind(this);
      this.handleTouchEnd = this.handleTouchEnd.bind(this);
      this.contextHandlers = ListItem.dependencies.contextMenuPolyfillService.getHandlers();

    } else {
      this.handleTouchStart = noop;
      this.handleTouchMove = noop;
      this.handleTouchEnd = noop;
    }
  }

  handleClick(e) {
    e.stopPropagation();
    if (isFunction(this.props.onClick)) {
      if (!isUndefined(this.props.bindParam)) {
        this.props.onClick(e, this.props.bindParam);
      } else {
        this.props.onClick(e);
      }
    }
  }

  handleContextMenu(e) {
    e.stopPropagation();
    e.preventDefault();
    if (isFunction(this.props.onContextMenu)) {
      if (!isUndefined(this.props.bindParam)) {
        this.props.onContextMenu(e, this.props.bindParam);
      } else {
        this.props.onContextMenu(e);
      }
    }
  }

  handleMouseDown() {
    this.setState({active: true});
  }

  handleMouseUp() {
    this.setState({active: false});
  }

  handleTouchStart(event) {
    this.contextHandlers.touchStartHandler({
      event,
      bindParam: this.props.bindParam,
      onContextMenu: this.props.onContextMenu,
    });
  }

  handleTouchMove(event) {
    this.contextHandlers.touchMoveHandler({
      event,
      bindParam: this.props.bindParam,
      onContextMenu: this.props.onContextMenu,
    });
  }

  handleTouchEnd(event) {
    this.contextHandlers.touchEndHandler({
      event,
      bindParam: this.props.bindParam,
      onContextMenu: this.props.onContextMenu,
    });
  }

  render() {
    const props = this.props;
    // props spread is to support any additional <div/> props
    //   it is first since the explicitly defined props must overwrite the component props
    return (
      <div
        className={classNames("BaseListItem", props.className, {
          BaseListItem_active: this.state.active,
        })}
        title={this.props.title}
        onClick={this.handleClick}
        onContextMenu={this.handleContextMenu}
        onTouchStart={this.handleTouchStart}
        onTouchMove={this.handleTouchMove}
        onTouchEnd={this.handleTouchEnd}
        onMouseDown={this.handleMouseDown}
        onMouseUp={this.handleMouseUp}
      >
        {props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/lists/ListItem/ListItem.js